window.addEventListener("load", () => {
    let headerElement = document.querySelector('.page-header-sticky .page-header');
    headerElement.classList.add('transparent');

    let isScrolling = false;

    window.addEventListener('scroll', () => {
        if (!isScrolling) {
            window.requestAnimationFrame(() => {
                if (window.scrollY === 0) {
                    console.log("Optimized check: At the top!");
                    headerElement.classList.add('transparent');
                } else {
                    // setTimeout(() => {
                        headerElement.classList.remove('transparent');
                    // }, 200);
                }
                isScrolling = false;
            });
            isScrolling = true;
        }
    });

    
});

document.addEventListener('DOMContentLoaded', () => {
  const startTestimonialsAutoplay = () => {
    const section = document.querySelector('.wt-test');
    if (!section) return;

    const swiperEl = section.querySelector('.swiper');

    if (!swiperEl || !swiperEl.swiper) {
      setTimeout(startTestimonialsAutoplay, 500);
      return;
    }

    const swiper = swiperEl.swiper;

    swiper.params.autoplay = {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: false
    };

    swiper.autoplay?.start();
  };

  startTestimonialsAutoplay();
});

